var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g2, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _circle, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 968.5 618.3",
    viewBox: "0 0 968.5 618.3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(1 0 0 -1 0 620)",
    gradientUnits: "userSpaceOnUse",
    x1: 489.3559,
    x2: 489.6559,
    y1: 565.42,
    y2: 343.66
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1 0 0 -1 -1511.98 -945.5601)",
    gradientUnits: "userSpaceOnUse",
    x1: 2185.6565,
    x2: 2270.7864,
    y1: -1407.4197,
    y2: -1446.8497
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a5bf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd94ef"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 -1511.98 -945.5601)",
    gradientUnits: "userSpaceOnUse",
    x1: 2198.8252,
    x2: 2255.4053,
    y1: -1396.9722,
    y2: -1423.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a5bf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5a4ed"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5aceed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#538bd6"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(1 0 0 -1 -707.48 -376.98)",
    gradientUnits: "userSpaceOnUse",
    x1: 1277.9457,
    x2: 1125.4733,
    xlinkHref: "#d",
    y1: -775.9096,
    y2: -775.9096
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 469.5835,
    x2: 554.6358,
    y1: 291.0774,
    y2: 291.0774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f87b58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8c548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89c51"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "matrix(1 0 0 -1 0 292)",
    gradientUnits: "userSpaceOnUse",
    x1: 433.4932,
    x2: 562.9027,
    y1: -38.7471,
    y2: -38.7471
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1a1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7658f4"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(1 0 0 -1 0 292)",
    gradientUnits: "userSpaceOnUse",
    x1: 459.4201,
    x2: 532.3234,
    xlinkHref: "#d",
    y1: 16.2216,
    y2: 16.2216
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(1 0 0 -1 0 -116)",
    gradientUnits: "userSpaceOnUse",
    x1: 495.3081,
    x2: 488.8113,
    y1: -484.519,
    y2: -484.519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59c2e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5bd3ef"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m57.1 393s-151.6-132.9 39.5-195.7c95.3-31.3 117.7-47.4 191.8-108 106-86.8 244.9-136.9 425.5 16.1s316.9 200.4 198 292.1c-133.7 103.1-52.3 156.1-69.1 185.2-4.5 7.7-32.7-25.3-94.9 8.7-141.7 77.5-213.8-40.4-318-11-98.3 27.8-148.8-33.6-180.8-9.6-47.7 35.8-77.6 35.3-95.5 25.9-15-7.9-23.8-24.2-23.1-41.3.8-19.4.9-55.8-6.9-82.3-11.8-40-40.7-60.4-66.5-80.1z",
    fill: "#f5f5fc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58.8 394.6s-153.1-135.7 39.9-199.9c96.2-32 118.8-48.4 193.6-110.4 107-88.6 247.2-139.9 429.4 16.4s324.3 211 199.8 298.5c-86.2 60.6-57 31-83.8 51.8-57 44-186.6-38.7-291.8-8.6-99.2 28.3-195.7-14-238.8-16.9-17.1-1.1-86-1.4-120.7-3.2-19.4-1-40.8 7.5-67.8 1.1-40.6-9.7-33.7-8.7-59.8-28.8z",
    fill: "#f8f8ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m223.3 142.3-49.7 33.5c-.7.4-1.8-6.7-2.5-6.4l-33.8 13-.4 242.9 211.5-2.6-1.6-329.2-64.4.5z",
    fill: "#e9edfb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b0c0f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m206.9 150.2-51.8 25.4-.1 6.8 172.5-1-.7-62.1-74.4-1-16.6 12.7c-2.9 2.2-6.5 4.6-11 7.6-7.5 4.9-12 8.2-17.9 11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.1 192.5v61.3l172.7-.3v-61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.6 264.8v61.3l172.6-.4.1-60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.5 338.1v61.3l172.7-.3v-61z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m215.2 299.6 8.1-10.6 30.1 26.8-7.6 10.9z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m155.5 276.7 19.5.1.1 49.4-19.5-.2z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m198.1 285.1 8-4.5 20.3 40.6-7.9 5.4z",
    fill: "#f5f5fc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m188.7 271.3h9.5l.2 55.1-9.7-.3z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m175.1 288.1 13.8.3-.2 37.9-13.8-.3z",
    fill: "#f5f5fc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m250.7 276.6 19.4.1.2 49.4-19.6-.3z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m283.9 271.2h9.4l.3 55-9.8-.2z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m270.3 288 13.8.2-.3 37.9-13.8-.2z",
    fill: "#f5f5fc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m156.5 343.2 14.9.1.1 56.6-14.9-.3z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m171.4 351.7 10.1-.1-.3 48.1-10-.1z",
    fill: "#f5f5fc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m181.5 361.6 13.7.2-.3 37.9-13.8-.2z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m265.5 174.1v7.1l55.2.4v-7.5z",
    fill: "#f5f5fc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m265.4 168.5.2 5.7 36 .2-.3-6.1z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m155.2 204.4 19.5.1.1 49.4-19.6-.3z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m306.9 212.3-8.2-4.5-21.1 40.6 8.3 5.3z",
    fill: "#f5f5fc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m318.5 198.5h9.5l.2 55-9.7-.2z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m305.5 215.6 13.8.2-.2 37.9-13.8-.2z",
    fill: "#f5f5fc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m212.6 246.6v7.1l55.2.4v-7.5z",
    fill: "#f5f5fc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m221.2 240.8.3 5.7 36 .2-.3-6.1z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m745.5 495.6s-16.6 19.6-3 20.1 41.5 16.3 46.8 2.2 16-21.2 9.5-22.8-12.4-8.2-26.1-7.1-27.2 7.6-27.2 7.6z",
    fill: "#f5f5fc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m741.2 400.3s-7.8.8-7.8 10.5 5 93.1 24 94.8c12.3 1.1 25.4 1 31.9.4 2.8-.3 5.5-8.7 6-12.1 2.5-16.6 5.7-57 6.4-80.5.1-4.8-3.1-11.1-4.8-12.7-9.5-8.7-55.7-.4-55.7-.4z",
    fill: "#e1e6fb"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m833.1 238.9c-3-2.8-7.2 1-5.6 4.9 1.5 3.8 2.6 10.3-3.5 17.3-9.4 10.9-43.3 47.7-42.9 71.4s-7 30.3 0 39.3 35.2 8.7 42.6-10.5 26.1-26.9 25.7-54.3-3.6-39.4-7-48.8c-2-5.9-5.4-15.6-9.3-19.3z",
    fill: "#e9edfb"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m781.8 396.8s3-42.9 36.5-61.6c21-11.7 22.4-52.3 17.4-61.5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m786.1 414.8s10.6 42.2-.9 75.7",
    fill: "#bac5f4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m810.2 229.6c-3.2-2.7-7.7.9-6 4.7 1.6 3.6 2.7 9.9-3.7 16.6-10.1 10.4-46.3 45.6-46 68.3s0 35.9 7.5 44.5 25 1.7 32.9-16.6 33.2-26.1 32.8-52.4c-.4-26.2-3.9-37.7-7.5-46.7-2.2-5.7-5.8-14.9-10-18.4z",
    fill: "#bac5f4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m767.8 397.7s-11.8-58.3 16.9-93.4c11.5-14 28.5-42.1 28.4-55.7",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m720.7 238.9c2.9-2.8 7.1 1 5.6 4.9-1.5 3.8-2.5 10.3 3.5 17.3 9.3 10.9 42.9 47.7 42.6 71.4s0 37.5-7 46.6-23.1 1.8-30.4-17.4-30.7-27.3-30.4-54.7 3.6-39.4 6.9-48.8c2-5.9 5.3-15.6 9.2-19.3z",
    fill: "#e9edfb"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m758.4 398.7s13.5-53-13.1-88c-10.6-14-27.7-34.8-27.5-48.3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m699.1 331.3s-27.8.6-42.8-33.1 18.8-40.6 43.6-22.5 14.7 25.6 44.3 42.3 23.2 49.8 14 58.6-26.6 22.5-38.2-13.3-20.9-32-20.9-32z",
    fill: "#b0c0f4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m753.1 399.1s2-84.4-81.7-107.6",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#bac5f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m741.2 400.3s34.1-5.5 47.4-2.6-23.5 6.3-23.5 6.3-17.6.8-23.9-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.8 409.2s-38.4-30.3-44.9-60 7.6-50.3 28.1-53.5 33-13 104.9 11.4 154.7-18.9 154.7-18.9 67.6-31.1 101-23.5c38 8.6 46.1 31.6 35.8 72.7s-45.3 72.2-45.3 72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.4 406s-6 0-7 6 1 25 4 31 17.1 5.7 17.1 5.7l342.9-.7s11.4.1 14-9c2.1-7.3 5.1-14.6 5.4-19.7.3-6-4-11.2-9.9-12-3.7-.5-7.5-.7-11.2-.7-26.1 0-355.3-.6-355.3-.6z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m294.4 499 23-50h18l-24 50z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m648.4 449 21 51 15-1-20-50z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m333.7 406.6s-31.6-24.4-33.1-34.5c-1.9-13.2 10-32.8 56.2-24.1s127.7 32.2 171.9 20.2 99.8-62.4 103.8-65.1 51.3-25.9 62 9.5-32.5 93.6-32.5 93.6z",
    fill: "#b0c0f4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m487.4 0 1.3 67.7 1.6-.3 1.4-67.4z",
    fill: "#bac5f4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m453.1 123.2s-12.6-56.5 37.3-57.1c47.2-.5 35.1 60 35.1 60z",
    fill: "#bac5f4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m452.6 123.2s40.1-17.4 72.9 2.7c0 0-34.5 18.3-72.9-2.7z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m472 76.2s-17.5 6.5-13.9 36.2",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m452.6 123.2-35.4 127.3 144.8-1.4-36.5-123.2z",
    fill: "url(#a)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m699.2 461.4s-11.1 40.3-9.3 44.8 10.8 5.4 14.8 6.3 40.3 10.4 44 10.6 3.4.7 5 .7 21.8-6.8 22.5-9.2 1.3-4 .7-7-9.8-41.4-12.3-42.2-65.4-4-65.4-4z",
    fill: "url(#b)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m697.3 468.6s.8-6.3 1.9-7.2 4.2-5 7.2-5.2 51.3 5.9 53.1 6.3 4.2 1.3 5 2.8-7 3.3-8.5 8.1-29.1 14.9-35.9 15.6-22.8-20.4-22.8-20.4z",
    fill: "url(#c)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m713.1 457.8s5.2-11.3 7.7-13.4c2.2-1.9 10.1-6 14.9.1 5.4 6.9 4.9 14.9 4.9 15.9s-5.3.1-5.3.1 1.7-8.2.2-11c-1.4-2.6-2.2-5.7-7.2-5.4s-6.8 3.1-8.3 5.7c-1.3 2.6-2.3 5.3-3.2 8.1-.2.3-3.7-.1-3.7-.1z",
    fill: "#7a5bf5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m721.4 458.5s5.2-13.8 7.7-16.4c2.2-2.3 10.6-6.9 15.4.5 5.4 8.4 4.3 17.8 4.3 18.9s-5.3.2-5.3.2 1.6-10 .1-13.5c-1.4-3.2-2.2-7-7.1-6.6s-6.8 3.7-8.3 7c-1.3 3.2-2.3 6.5-3.2 9.9 0 .5-3.6 0-3.6 0z",
    fill: "#7a5bf5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m753.9 476.2s-4.6 38.7-4 41.3 2.1 6.3 3.2 6.3 2.9-.2 2.2-1.1c-2.3-3.3-3.3-7.4-2.7-11.3.7-6.3 3.4-38 3.4-38z",
    fill: "#7a5bf5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 718.9,
    cy: 489,
    fill: "#fff",
    r: 2.8
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m527.2 416.4c-2.9-4.8-5.2-6-12.3-6.2s-16.5-.1-16.5-.1l-.1 10.1s7.8 4.5 12 6.8c.2.1.9.5 1.4.8.7.3 1.5.6 2.3.8 4.1.9 7.9.4 10.6-2.2 2.9-3 5.5-5.2 2.6-10z",
    fill: "#4b44be"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m473.7 407.5c-.2.2-.9.7-1.3 1-.6.5-1.1 1.2-1.6 1.8-2.3 3.5-3.4 7.1-1.8 10.6 1.7 3.8 2.8 7.1 8.2 6.1 5.4-.9 7.5-2.6 10.4-9s6.3-15.3 6.2-15.3l-9.3-3.8c-.1 0-7.2 5.6-10.8 8.6z",
    fill: "#4b44be"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m499.1 410.5s.1 10.2-1.5 10.4c-1.7.2-24.5-3.1-33.6-3.5-9.1-.5-29.7-6.4-39.8-17.8-8.8-9.9-7.4-20.8-.9-20.8s12.4-5.5 28.8 2.3 33.8 9.1 43.6 8.4c9.8-.8 37.2-5.8 39.3-7.4s12.4-6 26.7-4.5 7.5 12.9 4.5 17.3c-4.2 6.1-14.2 12.6-22.6 12.9s-44.5 2.7-44.5 2.7z",
    fill: "url(#e)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m482.1 232.8c-4.8 1.8-10.9 25.6-10.9 25.6l-.1-.1-.7 3.3-.8 4.3 1.6 25.9 15.6 7.8 35.7 9.6 9.9 14.1s22.1 22.5 22.3 24.1c.1 1.6-23.8 9.5-26.1 9.8-5.5.8 35.2-9.1 22.1-24.9-5.5-6.8-13.7-27.1-29.8-40.6-9.3-7.8-6.7-29.9-10-43.9-4.1-17.5-6.7-22.8-10.8-22.8-3.7 0-8.9 4.4-18 7.8",
    fill: "url(#f)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m532.7 289.4c-7.5-6.9-10-8.5-16.6-6.2s-9.8 4.5-18.7 5.9c-5.5 1-11.2.2-16.3-2l-18.4 1.8c-2.3-.3-28.5 48.9-29.2 59.1-.4 6.3 13.9 16 17.8 16.9 1.6.4 4.5-15.1 5.4-16.5l-6-1.8c1.1-2.7 4.7-9.3 7.1-12.8.7-1.1 6.4-10.5 7.2-14.1.1.3 1 7.1 1.8 9.3 1.5 4 3.5 6.3 3.5 9.5s-.4 16-2.7 21.7-5.7 19-5.7 19l58.9-.3s-2.1-25.3-1.3-34c0 0-.9-3.5.8-8.6 2.9-8.4 3.7-20.8 3.2-22.8-.7-3.1 17.3 22.9 21.3 29.4 1.7 2.7-20.8 7.5-22.6 9.6-1.9 2.2 1.9 8.1 1.9 8.1s39.1-4.8 38.9-10.7-21.6-52.6-30.3-60.5z",
    fill: "url(#g)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m486.8 218.8s-10.9.4-14.1 11.9-3.6 27.5-3.7 30c-.1 2.6 1.1 18-4.8 24.4-5.1 5.5-3 10.9-4.3 15.3l-.6 7.3c.1.9.7 1.6 1.6 1.9.8.2 3.5-1 4-1.2 6.8-2.7 6.8-4.9 9.4-7.1 2.1-1.8 8-6 9.8-7.6 1.8-1.7 3-3.1 3.1-5.2.3-10.6-1.5-20.5-3.8-25.7s-6.8-14-3.1-19.8 10.5-11.7 10.9-13.1.6 5.6 4.7 8.1 7.6 5.9 8.9 9.3c1.1 2.8 2.5 7.6-1.4 16-3.9 8.3-7.1 19-1.6 26.9s17.1 16.5 19 20.5c2.1 4.4.1 14.8-.3 21.1s12.3-10.9 11.9-19.1 1-11.7-6.9-24.2-12.9-34-13.1-39.2-2.5-19.6-7.2-23.8c-4.1-3.5-5-6.9-13.3-6.9-1.8-.1-3.4 0-5.1.2",
    fill: "url(#h)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m461.9 392.7 55.2.3s-6.5 5.1-9.6 5.6-16.4 7.2-21.4 4.7c-3.4-1.9-24.2-10.6-24.2-10.6z",
    opacity: 0.07
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m492.7 268.6s5.2 1.3 7.3-1.7c4.8-6.8.4 3.5.4 3.5s-1.4 4-1.3 6-5.5-7.5-6.4-7.8",
    opacity: 0.07
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m472.1 303.6c-.6.8-1.6 1.4-2 3.4-.8 3.2-1.7 6.8-3.9 10.1-1.3 1.9-.6 9.5 1.6 14.2.6 1.4 2.6 4.9 2.5 5.7l-.1 6.9h5.9s5.1.5 4-3.6c-.9-3.7-5.7-17.5-2.5-20.5 6.1-5.6-1.6-16.8 1.3-20.4 2.5-3.1 6-5.3 6-6.4 0-.4-.9.9-1.6 1.3-1.2.9-1.8 1.6-2.9 2.2-1.1.7-2.8 1.9-3.9 2.8-1.7 1.4-3.1 2.8-4.4 4.3z",
    opacity: 0.07
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m449 347.9s0-3.6 3.5-3.7 78.7 0 78.7 0 3.3.4 3.4 3.1.1 42.4.1 42.4 0 3.1-3.2 3.2-79.9.1-79.9.1-2.9-.7-2.8-3.6c0-3 .2-41.5.2-41.5z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 368.5,
    fill: "url(#i)",
    r: 3.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg51);
export default __webpack_public_path__ + "static/media/bg5-1.0469fa2bb6bfbc306254ff0007b54550.svg";
export { ForwardRef as ReactComponent };